module.exports = __webpack_public_path__ + "media/images/icons/sw-pt3-icon-4f5d38b056116f919b511db82cf083ba.svg";